import { IAsyncActionCreator, createAsyncActionCreator } from '../store/actions/createActionCreator';
import { IItemCacheThunkAction, IItemCacheDispatch, IItemCacheContext } from '../store/actions/ItemCacheActions';
import { errorHandlerFacet } from '../facets/ConfigurationFacets';

/**
 * @public
 */
export interface IHandleErrorPayload {
    error: Error;
}

/**
 * @public
 */
export const handleError: IAsyncActionCreator<IHandleErrorPayload, IItemCacheThunkAction<void>> =
    createAsyncActionCreator((payload: IHandleErrorPayload) => {
        const {
            error
        } = payload;

        return (dispatch: IItemCacheDispatch, getState: () => {}, context: IItemCacheContext) => {
            const errorHandler = errorHandlerFacet.unpack(context.configuration);

            if (errorHandler) {
                errorHandler(error);
            } else {
                window.setTimeout(() => {
                    throw error;
                }, 0);
            }
        };
    });
